import { render, staticRenderFns } from "./couponUseDetail.vue?vue&type=template&id=055cfb02&scoped=true"
import script from "./couponUseDetail.vue?vue&type=script&lang=js"
export * from "./couponUseDetail.vue?vue&type=script&lang=js"
import style0 from "./couponUseDetail.vue?vue&type=style&index=0&id=055cfb02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055cfb02",
  null
  
)

export default component.exports